import { render, staticRenderFns } from "./FullPage.vue?vue&type=template&id=47ec59ab&scoped=true"
import script from "./FullPage.vue?vue&type=script&lang=js"
export * from "./FullPage.vue?vue&type=script&lang=js"
import style0 from "./FullPage.vue?vue&type=style&index=0&id=47ec59ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec59ab",
  null
  
)

export default component.exports